import { render, staticRenderFns } from "./compensate.vue?vue&type=template&id=4dcffdc4&scoped=true&"
import script from "./compensate.vue?vue&type=script&lang=js&"
export * from "./compensate.vue?vue&type=script&lang=js&"
import style0 from "./compensate.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./compensate.vue?vue&type=style&index=1&id=4dcffdc4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcffdc4",
  null
  
)

export default component.exports